export default "__VITE_ASSET__D4SNYkNp__"